export const maxInitialSections = 4;
export const maxSwimlaneItems = 20;